module.exports = __webpack_public_path__ + "img/qrcodeBig.588ced46.png";